var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "473px",
    height: "329px",
    viewBox: "0 0 473 329",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "starter projects illustration") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 321,
    height: 225,
    rx: 6
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.3%",
    y: "-13.3%",
    width: "118.7%",
    height: "126.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L321,0 L321,177.002344 C321,180.314758 318.321352,183 314.997575,183 L6.00242477,183 C2.68737711,183 0,180.306904 0,177.002344 L0,0 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6360687,75.75 L93.9145311,75.75 C94.1676936,75.75 94.4208561,75.8767606 94.5474373,76.0035211 L95.8132498,77.2711268 C95.939831,77.3978873 96.1929935,77.5246479 96.446156,77.5246479 L99.3575246,77.5246479 C99.6106871,77.5246479 99.8638496,77.3978873 99.9904308,77.2711268 L101.256243,76.0035211 C101.382824,75.8767606 101.635987,75.75 101.889149,75.75 L121.365733,75.75 C121.872058,75.75 122.251801,76.1302817 122.251801,76.6373239 L122.251801,82.0880282 C122.251801,82.5950704 121.872058,82.9753521 121.365733,82.9753521 L101.889149,82.9753521 C101.635987,82.9753521 101.382824,83.1021127 101.256243,83.2288732 L99.9904308,84.4964789 C99.8638496,84.6232394 99.6106871,84.75 99.3575246,84.75 L96.446156,84.75 C96.1929935,84.75 95.939831,84.6232394 95.8132498,84.4964789 L94.5474373,83.2288732 C94.4208561,83.1021127 94.1676936,82.9753521 93.9145311,82.9753521 L91.6360687,82.9753521 C91.1297437,82.9753521 90.75,82.5950704 90.75,82.0880282 L90.75,76.6373239 C90.75,76.1302817 91.256325,75.75 91.6360687,75.75 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-6",
    x: 0,
    y: 153,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.7%",
    y: "-20.0%",
    width: "113.3%",
    height: "126.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.298039216   0 0 0 0 0.592156863   0 0 0 0 1  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowOffsetOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-8",
    x: 0,
    y: 0,
    width: 120,
    height: 90,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-10",
    x: 0,
    y: 0,
    width: 120,
    height: 90,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-12",
    x: 0,
    y: 0,
    width: 24,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,5.99430406 C0,2.68374134 2.67864768,0 6.00242477,0 L314.997575,0 C318.312623,0 321,2.68324555 321,5.99430406 L321,24 L0,24 L0,5.99430406 Z",
    id: "path-14"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.3%",
    y: "-4.2%",
    width: "100.6%",
    height: "108.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-15"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -2,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "V1_Ideas-Page",
    transform: "translate(-102.000000, -2259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Starter-Projects",
    transform: "translate(102.000000, 2259.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "starter-projects-illustration"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.883903,14.706504 C197.037782,-27.0922322 425.474577,34.1172225 417.181382,65.067847 C408.888187,96.0184716 350.225939,64.3956615 343.657623,88.9089478 C337.089308,113.422234 482.794344,132.680133 471.700679,174.082254 C460.607014,215.484374 310.146325,200.040779 303.224471,225.873488 C296.302617,251.706198 426.457778,266.547497 415.642849,306.909363 C404.827919,347.271229 295.115968,319.572646 257.370775,309.458852 C219.625583,299.345058 14.077805,242.720897 24.9304457,202.21829 C35.7830864,161.715683 128.718282,188.989822 137,158.082031 C145.281718,127.174241 38.3139485,101.216683 48,65.067847 C57.6860515,28.9190106 253.919855,95.0032689 259.832323,72.9376398 C265.74479,50.8720106 168.730024,56.5052403 182.883903,14.706504 Z M18.1444055,158.050519 C-7.48598233,147.671097 -3.37620489,116.341117 14.4450622,113.342051 C32.2663292,110.342985 59.4800142,127.742124 59.4800142,139.07744 C59.4800142,150.412755 43.7747933,168.429941 18.1444055,158.050519 Z",
    id: "Path-15",
    fill: "#FFAB19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Editor",
    transform: "translate(109.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Editor-Container",
    fill: "#D9E3F2",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Blocks",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 4.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,10.5 L187.5,10.5 C189.156854,10.5 190.5,11.8431458 190.5,13.5 L190.5,178.5 L0,178.5 L0,10.5 Z",
    id: "Workspace",
    stroke: "none",
    fill: "#E5F0FF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Add-Sprite",
    strokeOpacity: 0.15,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 177,
    cy: 165.75,
    r: 6.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Add-Sprite-Copy-2",
    strokeOpacity: 0.15,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 177,
    cy: 147.75,
    r: 6.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Add-Sprite-Copy-3",
    strokeOpacity: 0.15,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    cx: 177,
    cy: 129.75,
    r: 6.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Block-Menu",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(0.000000, 10.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Blocks-Menu",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 72,
    height: 168
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3860687,6.75 L25.6645311,6.75 C25.9176936,6.75 26.1708561,6.87676056 26.2974373,7.00352113 L27.5632498,8.27112676 C27.689831,8.39788732 27.9429935,8.52464789 28.196156,8.52464789 L31.1075246,8.52464789 C31.3606871,8.52464789 31.6138496,8.39788732 31.7404308,8.27112676 L33.0062432,7.00352113 C33.1328245,6.87676056 33.385987,6.75 33.6391495,6.75 L47.1157327,6.75 C47.6220577,6.75 48.0018015,7.13028169 48.0018015,7.63732394 L48.0018015,13.0880282 C48.0018015,13.5950704 47.6220577,13.9753521 47.1157327,13.9753521 L33.6391495,13.9753521 C33.385987,13.9753521 33.1328245,14.1021127 33.0062432,14.2288732 L31.7404308,15.4964789 C31.6138496,15.6232394 31.3606871,15.75 31.1075246,15.75 L28.196156,15.75 C27.9429935,15.75 27.689831,15.6232394 27.5632498,15.4964789 L26.2974373,14.2288732 C26.1708561,14.1021127 25.9176936,13.9753521 25.6645311,13.9753521 L23.3860687,13.9753521 C22.8797437,13.9753521 22.5,13.5950704 22.5,13.0880282 L22.5,7.63732394 C22.5,7.13028169 23.006325,6.75 23.3860687,6.75 Z",
    id: "Shape",
    stroke: "#4280D7",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1360687,132.75 L26.4145311,132.75 C26.6676936,132.75 26.9208561,132.876761 27.0474373,133.003521 L28.3132498,134.271127 C28.439831,134.397887 28.6929935,134.524648 28.946156,134.524648 L31.8575246,134.524648 C32.1106871,134.524648 32.3638496,134.397887 32.4904308,134.271127 L33.7562432,133.003521 C33.8828245,132.876761 34.135987,132.75 34.3891495,132.75 L44.8657327,132.75 C45.3720577,132.75 45.7518015,133.130282 45.7518015,133.637324 L45.7518015,139.088028 C45.7518015,139.59507 45.3720577,139.975352 44.8657328,139.975352 L34.3891495,139.975352 C34.135987,139.975352 33.8828245,140.102113 33.7562432,140.228873 L32.4904308,141.496479 C32.3638496,141.623239 32.1106871,141.75 31.8575246,141.75 L28.946156,141.75 C28.6929935,141.75 28.439831,141.623239 28.3132498,141.496479 L27.0474373,140.228873 C26.9208561,140.102113 26.6676936,139.975352 26.4145311,139.975352 L24.1360687,139.975352 C23.6297437,139.975352 23.25,139.59507 23.25,139.088028 L23.25,133.637324 C23.25,133.130282 23.756325,132.75 24.1360687,132.75 Z",
    id: "Shape-Copy-4",
    stroke: "#4280D7",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1360687,156.75 L26.4145311,156.75 C26.6676936,156.75 26.9208561,156.876761 27.0474373,157.003521 L28.3132498,158.271127 C28.439831,158.397887 28.6929935,158.524648 28.946156,158.524648 L31.8575246,158.524648 C32.1106871,158.524648 32.3638496,158.397887 32.4904308,158.271127 L33.7562432,157.003521 C33.8828245,156.876761 34.135987,156.75 34.3891495,156.75 L44.8657327,156.75 C45.3720577,156.75 45.7518015,157.130282 45.7518015,157.637324 L45.7518015,163.088028 C45.7518015,163.59507 45.3720577,163.975352 44.8657328,163.975352 L34.3891495,163.975352 C34.135987,163.975352 33.8828245,164.102113 33.7562432,164.228873 L32.4904308,165.496479 C32.3638496,165.623239 32.1106871,165.75 31.8575246,165.75 L28.946156,165.75 C28.6929935,165.75 28.439831,165.623239 28.3132498,165.496479 L27.0474373,164.228873 C26.9208561,164.102113 26.6676936,163.975352 26.4145311,163.975352 L24.1360687,163.975352 C23.6297437,163.975352 23.25,163.59507 23.25,163.088028 L23.25,157.637324 C23.25,157.130282 23.756325,156.75 24.1360687,156.75 Z",
    id: "Shape-Copy-6",
    stroke: "#4280D7",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1360687,144.75 L26.4145311,144.75 C26.6676936,144.75 26.9208561,144.876761 27.0474373,145.003521 L28.3132498,146.271127 C28.439831,146.397887 28.6929935,146.524648 28.946156,146.524648 L31.8575246,146.524648 C32.1106871,146.524648 32.3638496,146.397887 32.4904308,146.271127 L33.7562432,145.003521 C33.8828245,144.876761 34.135987,144.75 34.3891495,144.75 L41.8657327,144.75 C42.3720577,144.75 42.7518015,145.130282 42.7518015,145.637324 L42.7518015,151.088028 C42.7518015,151.59507 42.3720577,151.975352 41.8657327,151.975352 L34.3891495,151.975352 C34.135987,151.975352 33.8828245,152.102113 33.7562432,152.228873 L32.4904308,153.496479 C32.3638496,153.623239 32.1106871,153.75 31.8575246,153.75 L28.946156,153.75 C28.6929935,153.75 28.439831,153.623239 28.3132498,153.496479 L27.0474373,152.228873 C26.9208561,152.102113 26.6676936,151.975352 26.4145311,151.975352 L24.1360687,151.975352 C23.6297437,151.975352 23.25,151.59507 23.25,151.088028 L23.25,145.637324 C23.25,145.130282 23.756325,144.75 24.1360687,144.75 Z",
    id: "Shape-Copy-5",
    stroke: "#4280D7",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1360687,168.75 L26.4145311,168.75 C26.6676936,168.75 26.9208561,168.876761 27.0474373,169.003521 L28.3132498,170.271127 C28.439831,170.397887 28.6929935,170.524648 28.946156,170.524648 L31.8575246,170.524648 C32.1106871,170.524648 32.3638496,170.397887 32.4904308,170.271127 L33.7562432,169.003521 C33.8828245,168.876761 34.135987,168.75 34.3891495,168.75 L41.8657327,168.75 C42.3720577,168.75 42.7518015,169.130282 42.7518015,169.637324 L42.7518015,175.088028 C42.7518015,175.59507 42.3720577,175.975352 41.8657327,175.975352 L34.3891495,175.975352 C34.135987,175.975352 33.8828245,176.102113 33.7562432,176.228873 L32.4904308,177.496479 C32.3638496,177.623239 32.1106871,177.75 31.8575246,177.75 L28.946156,177.75 C28.6929935,177.75 28.439831,177.623239 28.3132498,177.496479 L27.0474373,176.228873 C26.9208561,176.102113 26.6676936,175.975352 26.4145311,175.975352 L24.1360687,175.975352 C23.6297437,175.975352 23.25,175.59507 23.25,175.088028 L23.25,169.637324 C23.25,169.130282 23.756325,168.75 24.1360687,168.75 Z",
    id: "Shape-Copy-12",
    stroke: "#4C95FF",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3860687,18.75 L25.6645311,18.75 C25.9176936,18.75 26.1708561,18.8767606 26.2974373,19.0035211 L27.5632498,20.2711268 C27.689831,20.3978873 27.9429935,20.5246479 28.196156,20.5246479 L31.1075246,20.5246479 C31.3606871,20.5246479 31.6138496,20.3978873 31.7404308,20.2711268 L33.0062432,19.0035211 C33.1328245,18.8767606 33.385987,18.75 33.6391495,18.75 L53.1157327,18.75 C53.6220577,18.75 54.0018015,19.1302817 54.0018015,19.6373239 L54.0018015,25.0880282 C54.0018015,25.5950704 53.6220577,25.9753521 53.1157327,25.9753521 L33.6391495,25.9753521 C33.385987,25.9753521 33.1328245,26.1021127 33.0062432,26.2288732 L31.7404308,27.4964789 C31.6138496,27.6232394 31.3606871,27.75 31.1075246,27.75 L28.196156,27.75 C27.9429935,27.75 27.689831,27.6232394 27.5632498,27.4964789 L26.2974373,26.2288732 C26.1708561,26.1021127 25.9176936,25.9753521 25.6645311,25.9753521 L23.3860687,25.9753521 C22.8797437,25.9753521 22.5,25.5950704 22.5,25.0880282 L22.5,19.6373239 C22.5,19.1302817 23.006325,18.75 23.3860687,18.75 Z",
    id: "Shape-Copy",
    stroke: "#4280D7",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3860687,30.75 L25.6645311,30.75 C25.9176936,30.75 26.1708561,30.8767606 26.2974373,31.0035211 L27.5632498,32.2711268 C27.689831,32.3978873 27.9429935,32.5246479 28.196156,32.5246479 L31.1075246,32.5246479 C31.3606871,32.5246479 31.6138496,32.3978873 31.7404308,32.2711268 L33.0062432,31.0035211 C33.1328245,30.8767606 33.385987,30.75 33.6391495,30.75 L53.1157327,30.75 C53.6220577,30.75 54.0018015,31.1302817 54.0018015,31.6373239 L54.0018015,37.0880282 C54.0018015,37.5950704 53.6220577,37.9753521 53.1157327,37.9753521 L33.6391495,37.9753521 C33.385987,37.9753521 33.1328245,38.1021127 33.0062432,38.2288732 L31.7404308,39.4964789 C31.6138496,39.6232394 31.3606871,39.75 31.1075246,39.75 L28.196156,39.75 C27.9429935,39.75 27.689831,39.6232394 27.5632498,39.4964789 L26.2974373,38.2288732 C26.1708561,38.1021127 25.9176936,37.9753521 25.6645311,37.9753521 L23.3860687,37.9753521 C22.8797437,37.9753521 22.5,37.5950704 22.5,37.0880282 L22.5,31.6373239 C22.5,31.1302817 23.006325,30.75 23.3860687,30.75 Z",
    id: "Shape-Copy-2",
    stroke: "#4280D7",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3860687,102.75 L25.6645311,102.75 C25.9176936,102.75 26.1708561,102.876761 26.2974373,103.003521 L27.5632498,104.271127 C27.689831,104.397887 27.9429935,104.524648 28.196156,104.524648 L31.1075246,104.524648 C31.3606871,104.524648 31.6138496,104.397887 31.7404308,104.271127 L33.0062432,103.003521 C33.1328245,102.876761 33.385987,102.75 33.6391495,102.75 L53.1157327,102.75 C53.6220577,102.75 54.0018015,103.130282 54.0018015,103.637324 L54.0018015,109.088028 C54.0018015,109.59507 53.6220577,109.975352 53.1157327,109.975352 L33.6391495,109.975352 C33.385987,109.975352 33.1328245,110.102113 33.0062432,110.228873 L31.7404308,111.496479 C31.6138496,111.623239 31.3606871,111.75 31.1075246,111.75 L28.196156,111.75 C27.9429935,111.75 27.689831,111.623239 27.5632498,111.496479 L26.2974373,110.228873 C26.1708561,110.102113 25.9176936,109.975352 25.6645311,109.975352 L23.3860687,109.975352 C22.8797437,109.975352 22.5,109.59507 22.5,109.088028 L22.5,103.637324 C22.5,103.130282 23.006325,102.75 23.3860687,102.75 Z",
    id: "Shape-Copy-3",
    stroke: "#4280D7",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.875,82.875 L85.875,92.625",
    id: "Line-4",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.625,82.875 L87.375,96.375",
    id: "Line-4-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.375,82.875 L94.125,91.875",
    id: "Line-4-Copy-2",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape-Copy-16",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#4C95FF",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFFFFF",
    strokeWidth: 2.25,
    d: "M96.532869,76.3996479 L99.2708115,76.3996479 L100.460185,75.2085893 C100.81019,74.8580889 101.353295,74.625 101.889149,74.625 L121.365733,74.625 C122.493735,74.625 123.376801,75.5093176 123.376801,76.6373239 L123.376801,82.0880282 C123.376801,83.2160345 122.493735,84.1003521 121.365733,84.1003521 L101.975863,84.1003521 L100.786489,85.2914107 C100.436484,85.6419111 99.8933795,85.875 99.3575246,85.875 L96.446156,85.875 C95.9103011,85.875 95.3671963,85.6419111 95.0171918,85.2914107 L93.827818,84.1003521 L91.6360687,84.1003521 C90.5080666,84.1003521 89.625,83.2160345 89.625,82.0880282 L89.625,76.6373239 C89.625,75.5244956 90.6130454,74.625 91.6360687,74.625 L93.9145311,74.625 C94.450386,74.625 94.9934908,74.8580889 95.3434953,75.2085893 L96.532869,76.3996479 Z"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#4C95FF",
    strokeWidth: 1.5,
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "hand",
    transform: "translate(107.000000, 76.750000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3566,11.158 C4.0926,11.158 2.1686,10.049 1.7826,8.52 C1.5776,7.712 1.2996,7.006 1.0546,6.383 C0.5356,5.061 0.0866,3.921 1.1076,3.155 C1.3356,2.985 1.5526,2.902 1.7716,2.902 C2.4246,2.902 2.6556,3.557 2.8246,4.037 C2.8296,4.052 2.8356,4.067 2.8416,4.084 C2.8116,3.97 2.7796,3.851 2.7536,3.759 C2.5456,2.999 2.1976,1.727 3.4776,1.177 C3.6706,1.093 3.8486,1.053 4.0206,1.053 C4.7136,1.053 4.9756,1.622 5.0976,2.221 C5.1656,1.412 5.4436,0.5 6.6006,0.5 C7.0856,0.5 7.3796,0.706 7.5416,0.879 C7.8056,1.16 7.9106,1.546 7.9446,1.953 C8.1536,1.482 8.4946,1.094 9.1136,1.094 C9.3076,1.094 9.5166,1.137 9.7336,1.225 C11.3216,1.862 10.2916,4.495 9.9536,5.361 C9.7726,5.823 9.8116,6.091 9.8486,6.185 C9.8536,6.135 9.9376,6.035 10.0166,5.838 C10.2526,5.241 10.7096,4.886 11.2376,4.886 C11.6076,4.886 11.9446,5.066 12.1646,5.382 C12.4546,5.798 12.4896,6.388 12.2616,7.002 C11.2956,9.604 9.0876,11.158 6.3576,11.158 L6.3566,11.158 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6008,-0.0002 C5.7438,-0.0002 5.2488,0.3828 4.9638,0.8838 C4.7348,0.6818 4.4298,0.5528 4.0208,0.5528 L4.0198,0.5528 C3.7828,0.5528 3.5328,0.6078 3.2798,0.7178 C2.3798,1.1038 2.0978,1.7768 2.0598,2.4308 C1.9708,2.4118 1.8748,2.4018 1.7718,2.4018 C1.4448,2.4018 1.1208,2.5208 0.8088,2.7558 C-0.5182,3.7488 0.0708,5.2448 0.5898,6.5648 C0.8298,7.1748 1.1008,7.8648 1.2978,8.6438 C1.7398,10.3898 3.8678,11.6578 6.3568,11.6578 C9.3058,11.6578 11.6878,9.9818 12.7298,7.1758 C13.0158,6.4068 12.9598,5.6488 12.5758,5.0968 C12.2658,4.6508 11.7658,4.3858 11.2378,4.3858 C11.0858,4.3858 10.9378,4.4058 10.7958,4.4468 C11.3718,2.4638 11.0788,1.2258 9.9198,0.7618 C9.6428,0.6498 9.3718,0.5938 9.1138,0.5938 C8.7208,0.5938 8.4088,0.7058 8.1598,0.8838 C8.0908,0.7608 8.0078,0.6448 7.9068,0.5368 C7.6768,0.2918 7.2638,-0.0002 6.6008,-0.0002 M6.6008,0.9998 C8.1208,0.9998 7.0448,3.7818 7.5588,3.9698 C7.5978,3.9828 7.6328,3.9888 7.6648,3.9888 C8.2878,3.9888 7.9838,1.5938 9.1138,1.5938 C9.2398,1.5938 9.3838,1.6238 9.5478,1.6888 C10.4568,2.0538 10.0758,3.6758 9.4878,5.1788 C9.1188,6.1218 9.4058,6.6918 9.7928,6.6918 C10.0278,6.6918 10.2978,6.4838 10.4808,6.0218 C10.6558,5.5818 10.9568,5.3858 11.2378,5.3858 C11.7088,5.3858 12.1228,5.9378 11.7928,6.8278 C10.7628,9.6028 8.4518,10.6578 6.3568,10.6578 C4.3828,10.6578 2.6008,9.7198 2.2678,8.3978 C1.6328,5.8888 0.3308,4.3618 1.4078,3.5558 C1.5518,3.4478 1.6708,3.4018 1.7718,3.4018 C2.3678,3.4018 2.3378,4.9928 2.9228,4.9928 C2.9558,4.9928 2.9908,4.9868 3.0278,4.9778 C4.2048,4.6398 2.0578,2.3318 3.6748,1.6358 C3.8078,1.5788 3.9218,1.5528 4.0208,1.5528 C5.0068,1.5528 4.4258,4.1558 5.1628,4.1558 C5.1738,4.1558 5.1848,4.1558 5.1968,4.1538 C6.0998,4.0618 4.8458,0.9998 6.6008,0.9998",
    id: "Fill-3",
    fill: "#575E75"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.3860687,48.75 L25.6645311,48.75 C25.9176936,48.75 26.1708561,48.8767606 26.2974373,49.0035211 L27.5632498,50.2711268 C27.689831,50.3978873 27.9429935,50.5246479 28.196156,50.5246479 L31.1075246,50.5246479 C31.3606871,50.5246479 31.6138496,50.3978873 31.7404308,50.2711268 L33.0062432,49.0035211 C33.1328245,48.8767606 33.385987,48.75 33.6391495,48.75 L57.6157327,48.75 C58.1220577,48.75 58.5018015,49.1302817 58.5018015,49.6373239 L58.5018015,55.0880282 C58.5018015,55.5950704 58.1220577,55.9753521 57.6157327,55.9753521 L33.6391495,55.9753521 C33.385987,55.9753521 33.1328245,56.1021127 33.0062432,56.2288732 L31.7404308,57.4964789 C31.6138496,57.6232394 31.3606871,57.75 31.1075246,57.75 L28.196156,57.75 C27.9429935,57.75 27.689831,57.6232394 27.5632498,57.4964789 L26.2974373,56.2288732 C26.1708561,56.1021127 25.9176936,55.9753521 25.6645311,55.9753521 L23.3860687,55.9753521 C22.8797437,55.9753521 22.5,55.5950704 22.5,55.0880282 L22.5,49.6373239 C22.5,49.1302817 23.006325,48.75 23.3860687,48.75 Z",
    id: "Shape-Copy-7",
    stroke: "#4280D7",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3860687,84.75 L25.6645311,84.75 C25.9176936,84.75 26.1708561,84.8767606 26.2974373,85.0035211 L27.5632498,86.2711268 C27.689831,86.3978873 27.9429935,86.5246479 28.196156,86.5246479 L31.1075246,86.5246479 C31.3606871,86.5246479 31.6138496,86.3978873 31.7404308,86.2711268 L33.0062432,85.0035211 C33.1328245,84.8767606 33.385987,84.75 33.6391495,84.75 L57.6157327,84.75 C58.1220577,84.75 58.5018015,85.1302817 58.5018015,85.6373239 L58.5018015,91.0880282 C58.5018015,91.5950704 58.1220577,91.9753521 57.6157327,91.9753521 L33.6391495,91.9753521 C33.385987,91.9753521 33.1328245,92.1021127 33.0062432,92.2288732 L31.7404308,93.4964789 C31.6138496,93.6232394 31.3606871,93.75 31.1075246,93.75 L28.196156,93.75 C27.9429935,93.75 27.689831,93.6232394 27.5632498,93.4964789 L26.2974373,92.2288732 C26.1708561,92.1021127 25.9176936,91.9753521 25.6645311,91.9753521 L23.3860687,91.9753521 C22.8797437,91.9753521 22.5,91.5950704 22.5,91.0880282 L22.5,85.6373239 C22.5,85.1302817 23.006325,84.75 23.3860687,84.75 Z",
    id: "Shape-Copy-10",
    stroke: "#4280D7",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.386069,133.5 L127.664531,133.5 C127.917694,133.5 128.170856,133.626761 128.297437,133.753521 L129.56325,135.021127 C129.689831,135.147887 129.942993,135.274648 130.196156,135.274648 L133.107525,135.274648 C133.360687,135.274648 133.61385,135.147887 133.740431,135.021127 L135.006243,133.753521 C135.132824,133.626761 135.385987,133.5 135.639149,133.5 L159.615733,133.5 C160.122058,133.5 160.501801,133.880282 160.501801,134.387324 L160.501801,139.838028 C160.501801,140.34507 160.122058,140.725352 159.615733,140.725352 L135.639149,140.725352 C135.385987,140.725352 135.132824,140.852113 135.006243,140.978873 L133.740431,142.246479 C133.61385,142.373239 133.360687,142.5 133.107525,142.5 L130.196156,142.5 C129.942993,142.5 129.689831,142.373239 129.56325,142.246479 L128.297437,140.978873 C128.170856,140.852113 127.917694,140.725352 127.664531,140.725352 L125.386069,140.725352 C124.879744,140.725352 124.5,140.34507 124.5,139.838028 L124.5,134.387324 C124.5,133.880282 125.006325,133.5 125.386069,133.5 Z",
    id: "Shape-Copy-13",
    stroke: "#4280D7",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.386069,122.25 L127.664531,122.25 C127.917694,122.25 128.170856,122.376761 128.297437,122.503521 L129.56325,123.771127 C129.689831,123.897887 129.942993,124.024648 130.196156,124.024648 L133.107525,124.024648 C133.360687,124.024648 133.61385,123.897887 133.740431,123.771127 L135.006243,122.503521 C135.132824,122.376761 135.385987,122.25 135.639149,122.25 L150.615733,122.25 C151.122058,122.25 151.501801,122.630282 151.501801,123.137324 L151.501801,128.588028 C151.501801,129.09507 151.122058,129.475352 150.615733,129.475352 L135.639149,129.475352 C135.385987,129.475352 135.132824,129.602113 135.006243,129.728873 L133.740431,130.996479 C133.61385,131.123239 133.360687,131.25 133.107525,131.25 L130.196156,131.25 C129.942993,131.25 129.689831,131.123239 129.56325,130.996479 L128.297437,129.728873 C128.170856,129.602113 127.917694,129.475352 127.664531,129.475352 L125.386069,129.475352 C124.879744,129.475352 124.5,129.09507 124.5,128.588028 L124.5,123.137324 C124.5,122.630282 125.006325,122.25 125.386069,122.25 Z",
    id: "Shape-Copy-14",
    stroke: "#855CD6",
    strokeWidth: 1.5,
    fill: "#9966FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.209605,41.7253521 L101.209605,52.4827881 C101.209605,53.7254288 102.216965,54.7327881 103.459605,54.7327881 L107.414531,54.7327881 C107.667694,54.7327881 107.920856,54.8595486 108.047437,54.9863092 L109.31325,56.2539148 C109.439831,56.3806754 109.692993,56.507436 109.946156,56.507436 L112.857525,56.507436 C113.110687,56.507436 113.36385,56.3806754 113.490431,56.2539148 L114.756243,54.9863092 C114.882824,54.8595486 115.135987,54.7327881 115.389149,54.7327881 L130.365733,54.7327881 C130.872058,54.7327881 131.251801,55.1130698 131.251801,55.620112 L131.251801,61.0708163 C131.251801,61.5778585 130.872058,61.9581402 130.365733,61.9581402 L108.598755,61.9581402 C108.345592,61.9581402 108.09243,62.0849008 107.965849,62.2116613 L106.700036,63.479267 C106.573455,63.6060275 106.320292,63.7327881 106.06713,63.7327881 L103.155761,63.7327881 C102.902599,63.7327881 102.649436,63.6060275 102.522855,63.479267 L101.257043,62.2116613 C101.130461,62.0849008 100.877299,61.9581402 100.624137,61.9581402 L98.3456741,61.9581402 C97.8393492,61.9581402 97.4596054,61.5778585 97.4596054,61.0708163 L97.4596054,33.1373239 C97.4596054,32.6302817 97.9659304,32.25 98.3456741,32.25 L100.624137,32.25 C100.877299,32.25 101.130461,32.3767606 101.257043,32.5035211 L102.522855,33.7711268 C102.649436,33.8978873 102.902599,34.0246479 103.155761,34.0246479 L106.06713,34.0246479 C106.320292,34.0246479 106.573455,33.8978873 106.700036,33.7711268 L107.965849,32.5035211 C108.09243,32.3767606 108.345592,32.25 108.598755,32.25 L129.575338,32.25 C130.081663,32.25 130.461407,32.6302817 130.461407,33.1373239 L130.461407,38.5880282 C130.461407,39.0950704 130.081663,39.4753521 129.575338,39.4753521 L115.459605,39.4753521 C115.206443,39.4753521 114.95328,39.6021127 114.826699,39.7288732 L113.560887,40.9964789 C113.434306,41.1232394 113.181143,41.25 112.927981,41.25 L110.016612,41.25 C109.763449,41.25 109.510287,41.1232394 109.383706,40.9964789 L108.117893,39.7288732 C107.991312,39.6021127 107.73815,39.4753521 107.484987,39.4753521 L103.459605,39.4753521 C102.216965,39.4753521 101.209605,40.4827114 101.209605,41.7253521 Z",
    id: "Path",
    stroke: "#EC9C13",
    strokeWidth: 1.5,
    fill: "#FFAB19",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.136069,43.5 L107.414531,43.5 C107.667694,43.5 107.920856,43.6267606 108.047437,43.7535211 L109.31325,45.0211268 C109.439831,45.1478873 109.692993,45.2746479 109.946156,45.2746479 L112.857525,45.2746479 C113.110687,45.2746479 113.36385,45.1478873 113.490431,45.0211268 L114.756243,43.7535211 C114.882824,43.6267606 115.135987,43.5 115.389149,43.5 L138.836221,43.5 C139.342546,43.5 139.72229,43.8802817 139.72229,44.3873239 L139.72229,49.8380282 C139.72229,50.3450704 139.342546,50.7253521 138.836221,50.7253521 L115.389149,50.7253521 C115.135987,50.7253521 114.882824,50.8521127 114.756243,50.9788732 L113.490431,52.2464789 C113.36385,52.3732394 113.110687,52.5 112.857525,52.5 L109.946156,52.5 C109.692993,52.5 109.439831,52.3732394 109.31325,52.2464789 L108.047437,50.9788732 C107.920856,50.8521127 107.667694,50.7253521 107.414531,50.7253521 L105.136069,50.7253521 C104.629744,50.7253521 104.25,50.3450704 104.25,49.8380282 L104.25,44.3873239 C104.25,43.8802817 104.756325,43.5 105.136069,43.5 Z",
    id: "Shape-Copy-20",
    stroke: "#855CD6",
    strokeWidth: 1.5,
    fill: "#9966FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.577332,107.25 C138.802185,107.25 141.155861,111.017212 141.155861,111.017212 L153.615733,111.017212 C154.122058,111.017212 154.501802,111.397494 154.501802,111.904536 L154.501802,117.35524 C154.501802,117.862282 154.122058,118.242564 153.615733,118.242564 L135.639149,118.242564 C135.385987,118.242564 135.132824,118.369325 135.006243,118.496085 L133.740431,119.763691 C133.61385,119.890451 133.360687,120.017212 133.107525,120.017212 L130.196156,120.017212 C129.942993,120.017212 129.689831,119.890451 129.56325,119.763691 L128.297437,118.496085 C128.170856,118.369325 127.917694,118.242564 127.664531,118.242564 L125.386069,118.242564 C124.879744,118.242564 124.5,117.862282 124.5,117.35524 L124.5,111.017212 C124.5,111.017212 126.352478,107.25 132.577332,107.25 Z",
    id: "Shape-Copy-15",
    stroke: "#E6AC00",
    strokeWidth: 1.5,
    fill: "#FFBF00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.577332,17.25 C111.802185,17.25 114.155861,21.0172119 114.155861,21.0172119 L126.615733,21.0172119 C127.122058,21.0172119 127.501802,21.3974936 127.501802,21.9045359 L127.501802,27.3552401 C127.501802,27.8622823 127.122058,28.242564 126.615733,28.242564 L108.639149,28.242564 C108.385987,28.242564 108.132824,28.3693246 108.006243,28.4960852 L106.740431,29.7636908 C106.61385,29.8904514 106.360687,30.0172119 106.107525,30.0172119 L103.196156,30.0172119 C102.942993,30.0172119 102.689831,29.8904514 102.56325,29.7636908 L101.297437,28.4960852 C101.170856,28.3693246 100.917694,28.242564 100.664531,28.242564 L98.3860687,28.242564 C97.8797437,28.242564 97.5,27.8622823 97.5,27.3552401 L97.5,21.0172119 C97.5,21.0172119 99.352478,17.25 105.577332,17.25 Z",
    id: "Shape-Copy-19",
    stroke: "#E6AC00",
    strokeWidth: 1.5,
    fill: "#FFBF00",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3860687,72.75 L25.6645311,72.75 C25.9176936,72.75 26.1708561,72.8767606 26.2974373,73.0035211 L27.5632498,74.2711268 C27.689831,74.3978873 27.9429935,74.5246479 28.196156,74.5246479 L31.1075246,74.5246479 C31.3606871,74.5246479 31.6138496,74.3978873 31.7404308,74.2711268 L33.0062432,73.0035211 C33.1328245,72.8767606 33.385987,72.75 33.6391495,72.75 L63.6157327,72.75 C64.1220577,72.75 64.5018015,73.1302817 64.5018015,73.6373239 L64.5018015,79.0880282 C64.5018015,79.5950704 64.1220577,79.9753521 63.6157327,79.9753521 L33.6391495,79.9753521 C33.385987,79.9753521 33.1328245,80.1021127 33.0062432,80.2288732 L31.7404308,81.4964789 C31.6138496,81.6232394 31.3606871,81.75 31.1075246,81.75 L28.196156,81.75 C27.9429935,81.75 27.689831,81.6232394 27.5632498,81.4964789 L26.2974373,80.2288732 C26.1708561,80.1021127 25.9176936,79.9753521 25.6645311,79.9753521 L23.3860687,79.9753521 C22.8797437,79.9753521 22.5,79.5950704 22.5,79.0880282 L22.5,73.6373239 C22.5,73.1302817 23.006325,72.75 23.3860687,72.75 Z",
    id: "Shape-Copy-9",
    stroke: "#4280D7",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3860687,114.75 L25.6645311,114.75 C25.9176936,114.75 26.1708561,114.876761 26.2974373,115.003521 L27.5632498,116.271127 C27.689831,116.397887 27.9429935,116.524648 28.196156,116.524648 L31.1075246,116.524648 C31.3606871,116.524648 31.6138496,116.397887 31.7404308,116.271127 L33.0062432,115.003521 C33.1328245,114.876761 33.385987,114.75 33.6391495,114.75 L63.6157327,114.75 C64.1220577,114.75 64.5018015,115.130282 64.5018015,115.637324 L64.5018015,121.088028 C64.5018015,121.59507 64.1220577,121.975352 63.6157327,121.975352 L33.6391495,121.975352 C33.385987,121.975352 33.1328245,122.102113 33.0062432,122.228873 L31.7404308,123.496479 C31.6138496,123.623239 31.3606871,123.75 31.1075246,123.75 L28.196156,123.75 C27.9429935,123.75 27.689831,123.623239 27.5632498,123.496479 L26.2974373,122.228873 C26.1708561,122.102113 25.9176936,121.975352 25.6645311,121.975352 L23.3860687,121.975352 C22.8797437,121.975352 22.5,121.59507 22.5,121.088028 L22.5,115.637324 C22.5,115.130282 23.006325,114.75 23.3860687,114.75 Z",
    id: "Shape-Copy-11",
    stroke: "#4280D7",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3860687,60.75 L25.6645311,60.75 C25.9176936,60.75 26.1708561,60.8767606 26.2974373,61.0035211 L27.5632498,62.2711268 C27.689831,62.3978873 27.9429935,62.5246479 28.196156,62.5246479 L31.1075246,62.5246479 C31.3606871,62.5246479 31.6138496,62.3978873 31.7404308,62.2711268 L33.0062432,61.0035211 C33.1328245,60.8767606 33.385987,60.75 33.6391495,60.75 L54.6157327,60.75 C55.1220577,60.75 55.5018015,61.1302817 55.5018015,61.6373239 L55.5018015,67.0880282 C55.5018015,67.5950704 55.1220577,67.9753521 54.6157327,67.9753521 L33.6391495,67.9753521 C33.385987,67.9753521 33.1328245,68.1021127 33.0062432,68.2288732 L31.7404308,69.4964789 C31.6138496,69.6232394 31.3606871,69.75 31.1075246,69.75 L28.196156,69.75 C27.9429935,69.75 27.689831,69.6232394 27.5632498,69.4964789 L26.2974373,68.2288732 C26.1708561,68.1021127 25.9176936,67.9753521 25.6645311,67.9753521 L23.3860687,67.9753521 C22.8797437,67.9753521 22.5,67.5950704 22.5,67.0880282 L22.5,61.6373239 C22.5,61.1302817 23.006325,60.75 23.3860687,60.75 Z",
    id: "Shape-Copy-8",
    stroke: "#4280D7",
    strokeWidth: 1.5,
    fill: "#4C95FF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Category-Menu",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(0.000000, 10.500000)"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeOpacity: 0.05,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: -0.75,
    y: -0.75,
    width: 16.5,
    height: 169.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-4"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#4C97FF",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Data",
    strokeOpacity: 0.1,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "#FF8C1A",
    cx: 7.5,
    cy: 93,
    r: 3.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Operators",
    strokeOpacity: 0.1,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "#59C059",
    cx: 7.5,
    cy: 81,
    r: 3.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Sensing",
    strokeOpacity: 0.1,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "#5CB1D6",
    cx: 7.5,
    cy: 69,
    r: 3.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Control",
    strokeOpacity: 0.1,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "#FFAB19",
    cx: 7.5,
    cy: 57,
    r: 3.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Events",
    strokeOpacity: 0.1,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "#FFBF00",
    cx: 7.5,
    cy: 45,
    r: 3.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Sounds",
    strokeOpacity: 0.1,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "#CF63CF",
    cx: 7.5,
    cy: 33,
    r: 3.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Looks",
    strokeOpacity: 0.1,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "#9966FF",
    cx: 7.5,
    cy: 21,
    r: 3.75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Motion",
    strokeOpacity: 0.1,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "#4C97FF",
    cx: 7.5,
    cy: 9,
    r: 3.75
  })), /*#__PURE__*/React.createElement("g", {
    id: "Workspace-Tabs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Blocks-off"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5625,9.9375 L23.4375,9.9375 L23.4375,3.00887858 C23.4375,1.65958749 22.3479177,0.5625 21.0089096,0.5625 L2.99109042,0.5625 C1.65220068,0.5625 0.5625,1.6580199 0.5625,3.00887858 L0.5625,9.9375 Z",
    id: "Costumes-Tab",
    stroke: "#E6EBF2",
    strokeWidth: 1.125,
    fillOpacity: 0.75,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Costumes",
    fillOpacity: 0.1,
    fill: "#000000",
    x: 6,
    y: 4.5,
    width: 12,
    height: 3,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Blocks-on"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.00887858 C0,1.34712083 1.34177063,0 2.99109042,0 L21.0089096,0 C22.6608432,0 24,1.35119576 24,3.00887858 L24,10.5 L0,10.5 L0,3.00887858 Z",
    id: "Blocks-Tab",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Blocks",
    fill: "#4C97FF",
    x: 6,
    y: 4,
    width: 12,
    height: 3,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Costumes-off",
    transform: "translate(24.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5625,9.9375 L23.4375,9.9375 L23.4375,3.00887858 C23.4375,1.65958749 22.3479177,0.5625 21.0089096,0.5625 L2.99109042,0.5625 C1.65220068,0.5625 0.5625,1.6580199 0.5625,3.00887858 L0.5625,9.9375 Z",
    id: "Costumes-Tab",
    stroke: "#D9E3F2",
    strokeWidth: 1.125,
    fillOpacity: 0.75,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Costumes",
    fillOpacity: 0.15,
    fill: "#000000",
    x: 6,
    y: 4,
    width: 12,
    height: 3,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Sounds-off",
    transform: "translate(48.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5625,9.9375 L23.4375,9.9375 L23.4375,3.00887858 C23.4375,1.65958749 22.3479177,0.5625 21.0089096,0.5625 L2.99109042,0.5625 C1.65220068,0.5625 0.5625,1.6580199 0.5625,3.00887858 L0.5625,9.9375 Z",
    id: "Sounds-Tab",
    stroke: "#D9E3F2",
    strokeWidth: 1.125,
    fillOpacity: 0.75,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Sounds",
    fillOpacity: 0.15,
    fill: "#000000",
    x: 6,
    y: 4,
    width: 12,
    height: 3,
    rx: 1.5
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Stage",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Stage",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Stage",
    stroke: "none",
    fill: "#575E75",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4937504,18.1532717 C25.3035748,17.9360352 25.9360352,17.3035748 26.1532717,16.4937504 L26.6482407,14.6527405 C26.883351,13.7824198 28.1180239,13.7824198 28.3517593,14.6527405 L28.8481032,16.4937504 C29.0653397,17.3035748 29.6978001,17.9360352 30.5062496,18.1532717 L32.3472595,18.6482407 C33.2175802,18.883351 33.2175802,20.1180239 32.3472595,20.3531342 L30.5062496,20.8481032 C29.6978001,21.0653397 29.0653397,21.6978001 28.8481032,22.5062496 L28.3517593,24.3472595 C28.1180239,25.2175802 26.883351,25.2175802 26.6482407,24.3472595 L26.1532717,22.5062496 C25.9360352,21.6978001 25.3035748,21.0653397 24.4937504,20.8481032 L22.6527405,20.3531342 C21.7824198,20.1180239 21.7824198,18.883351 22.6527405,18.6482407 L24.4937504,18.1532717 Z",
    id: "Fill-1",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    mask: "url(#mask-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7607962,21.9289732 C87.3068246,21.5142491 88.5142491,20.3068246 88.9289732,18.7607962 L89.8739141,15.2461409 C90.3227611,13.5846197 92.6798638,13.5846197 93.1260859,15.2461409 L94.0736516,18.7607962 C94.4883757,20.3068246 95.6958003,21.5142491 97.2392038,21.9289732 L100.753859,22.8739141 C102.41538,23.3227611 102.41538,25.6798638 100.753859,26.1287107 L97.2392038,27.0736516 C95.6958003,27.4883757 94.4883757,28.6958003 94.0736516,30.2392038 L93.1260859,33.7538591 C92.6798638,35.4153803 90.3227611,35.4153803 89.8739141,33.7538591 L88.9289732,30.2392038 C88.5142491,28.6958003 87.3068246,27.4883757 85.7607962,27.0736516 L82.2461409,26.1287107 C80.5846197,25.6798638 80.5846197,23.3227611 82.2461409,22.8739141 L85.7607962,21.9289732 Z",
    id: "Fill-1-Copy-6",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    mask: "url(#mask-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0955145,37.1711936 L94,90 L-8,90 L36.9044855,37.1711936 C39.7659762,33.8047339 44.8147276,33.3953756 48.1811874,36.2568664 C48.5101349,36.5364718 48.8159091,36.8422461 49.0955145,37.1711936 Z",
    id: "Triangle",
    stroke: "none",
    fill: "#0EBD8C",
    fillRule: "evenodd",
    mask: "url(#mask-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.599013,54.1851383 L131,90 L58,90 L88.4009872,54.1851383 C91.2602035,50.8167466 96.3086772,50.4039783 99.677069,53.2631945 C100.008956,53.5449128 100.317295,53.8532511 100.599013,54.1851383 Z",
    id: "Triangle-Copy",
    stroke: "none",
    fill: "#0EA57A",
    fillRule: "evenodd",
    mask: "url(#mask-11)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-10",
    stroke: "none",
    fillOpacity: 0.11,
    fill: "#000000",
    fillRule: "evenodd",
    mask: "url(#mask-11)",
    x: 102,
    y: 103.5,
    width: 12,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,70.7753747 C55,77.282762 49.6081847,80.0020087 42.9848898,80.0020087 C36.3641133,80.0020087 31,77.282762 31,70.7753747 C31,69.167085 31.2745016,67.8062246 31.8058762,66.6680503 L31.6044071,57.2657416 C31.5792235,56.2265391 32.7628541,55.632709 33.6190976,56.251282 L38.7313746,60.0369484 C39.9150052,59.4183755 41.3756558,59.1462034 42.9848898,59.1462034 C44.5991605,59.1462034 46.0849948,59.4183755 47.2686254,60.0369484 L52.3809024,56.251282 C53.2119622,55.632709 54.3955929,56.2265391 54.3955929,57.2657416 L54.1941238,66.6680503 C54.7229801,67.8062246 55,69.167085 55,70.7753747",
    id: "Fill-1",
    stroke: "#DB6E00",
    strokeWidth: 1.5,
    fill: "#FF8C1A",
    fillRule: "evenodd",
    mask: "url(#mask-11)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Sprite-Info-Area",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.99253976 C0,1.33980569 1.34209558,0 2.99446106,0 L87.0055389,0 C88.6593341,0 90,1.35292554 90,2.99253976 L90,18 L0,18 L0,2.99253976 Z",
    id: "stage-copy",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fillOpacity: 0.15,
    fill: "#000000",
    x: 4.5,
    y: 4.5,
    width: 18,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy",
    fillOpacity: 0.15,
    fill: "#000000",
    x: 4.5,
    y: 10.5,
    width: 6,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-2",
    fillOpacity: 0.15,
    fill: "#000000",
    x: 13.5,
    y: 10.5,
    width: 6,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-5",
    fillOpacity: 0.15,
    fill: "#000000",
    x: 43.5,
    y: 4.5,
    width: 6,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-7",
    fillOpacity: 0.15,
    fill: "#000000",
    x: 70.5,
    y: 4.5,
    width: 6,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-3",
    fillOpacity: 0.15,
    fill: "#000000",
    x: 22.5,
    y: 10.5,
    width: 6,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-6",
    fillOpacity: 0.15,
    fill: "#000000",
    x: 52.5,
    y: 4.5,
    width: 6,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-8",
    fillOpacity: 0.15,
    fill: "#000000",
    x: 79.5,
    y: 4.5,
    width: 6,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-4",
    fillOpacity: 0.15,
    fill: "#000000",
    x: 43.5,
    y: 10.5,
    width: 12,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2-Copy-9",
    fillOpacity: 0.15,
    fill: "#000000",
    x: 60,
    y: 10.5,
    width: 25.5,
    height: 3,
    rx: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Sprite-List",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(195.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Sprite-Area",
    stroke: "none",
    fill: "#E5F0FF",
    points: "0 0 90 0 90 54 0 54"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Add-Sprite",
    strokeOpacity: 0.2,
    stroke: "#4C97FF",
    strokeWidth: 1.5,
    fill: "#4C97FF",
    cx: 79.5,
    cy: 43.5,
    r: 6.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "cat",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "sprite-selected",
    stroke: "#4C97FF",
    strokeWidth: 1.5,
    fill: "#FFFFFF",
    x: 0.75,
    y: 0.75,
    width: 16.5,
    height: 16.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "sprite-selected-copy",
    strokeOpacity: 0.15,
    stroke: "#000000",
    strokeWidth: 1.5,
    x: 20.75,
    y: 0.75,
    width: 16.5,
    height: 16.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2670458,7.77570152 C27.0032498,7.57821386 27.5782139,7.0032498 27.7757015,6.26704581 L28.2256734,4.59340041 C28.43941,3.80219986 29.5618399,3.80219986 29.7743266,4.59340041 L30.2255484,6.26704581 C30.4230361,7.0032498 30.9980001,7.57821386 31.7329542,7.77570152 L33.4065996,8.2256734 C34.1978001,8.43941004 34.1978001,9.56183989 33.4065996,9.77557653 L31.7329542,10.2255484 C30.9980001,10.4230361 30.4230361,10.9980001 30.2255484,11.7329542 L29.7743266,13.4065996 C29.5618399,14.1978001 28.43941,14.1978001 28.2256734,13.4065996 L27.7757015,11.7329542 C27.5782139,10.9980001 27.0032498,10.4230361 26.2670458,10.2255484 L24.5934004,9.77557653 C23.8021999,9.56183989 23.8021999,8.43941004 24.5934004,8.2256734 L26.2670458,7.77570152 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "sprite-selected-copy",
    strokeOpacity: 0.15,
    stroke: "#000000",
    strokeWidth: 1.5,
    x: 41.25,
    y: 0.75,
    width: 16.5,
    height: 16.5,
    rx: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7670458,7.77570152 C47.5032498,7.57821386 48.0782139,7.0032498 48.2757015,6.26704581 L48.7256734,4.59340041 C48.93941,3.80219986 50.0618399,3.80219986 50.2743266,4.59340041 L50.7255484,6.26704581 C50.9230361,7.0032498 51.4980001,7.57821386 52.2329542,7.77570152 L53.9065996,8.2256734 C54.6978001,8.43941004 54.6978001,9.56183989 53.9065996,9.77557653 L52.2329542,10.2255484 C51.4980001,10.4230361 50.9230361,10.9980001 50.7255484,11.7329542 L50.2743266,13.4065996 C50.0618399,14.1978001 48.93941,14.1978001 48.7256734,13.4065996 L48.2757015,11.7329542 C48.0782139,10.9980001 47.5032498,10.4230361 46.7670458,10.2255484 L45.0934004,9.77557653 C44.3021999,9.56183989 44.3021999,8.43941004 45.0934004,8.2256734 L46.7670458,7.77570152 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99433368,13.5007533 C6.5115425,13.5007533 4.5,12.4810358 4.5,10.0407655 C4.5,9.43765689 4.60293809,8.92733421 4.80220357,8.50051888 L4.72665268,4.97465311 C4.71720881,4.58495215 5.1610703,4.36226589 5.48216159,4.59423075 L7.39926548,6.01385565 C7.84312697,5.7818908 8.39087093,5.67982626 8.99433368,5.67982626 C9.5996852,5.67982626 10.156873,5.7818908 10.6007345,6.01385565 L12.5178384,4.59423075 C12.8294858,4.36226589 13.2733473,4.58495215 13.2733473,4.97465311 L13.1977964,8.50051888 C13.3961175,8.92733421 13.5,9.43765689 13.5,10.0407655 C13.5,12.4810358 11.4780693,13.5007533 8.99433368,13.5007533 Z",
    id: "Fill-1",
    fill: "#FF8C1A"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Stage-Area",
    mask: "url(#mask-4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(291.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,3.0020839 C0,1.34407874 1.34177063,0 2.99109042,0 L21.0089096,0 C22.6608432,0 24,1.34240766 24,3.0020839 L24,72 L0,72 L0,3.0020839 Z",
    id: "Stage-Area",
    stroke: "none",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Add-Sprite-Copy",
    strokeOpacity: 0.2,
    stroke: "#4C97FF",
    strokeWidth: 1.5,
    fill: "#4C97FF",
    fillRule: "evenodd",
    cx: 12,
    cy: 61.5,
    r: 6.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0.000000, 17.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Stage",
    fill: "#575E75",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1238786,7.79279839 L18.8,18 L-1.6,18 L7.07612136,7.79279839 C7.79149406,6.95118346 9.05368191,6.84884391 9.89529684,7.5642166 C9.97753372,7.63411795 10.0539773,7.71056151 10.1238786,7.79279839 Z",
    id: "Triangle",
    fill: "#0EBD8C",
    mask: "url(#mask-13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4247532,11.1962846 L26.2,18 L11.6,18 L17.3752468,11.1962846 C18.0900509,10.3541866 19.3521693,10.2509946 20.1942672,10.9657986 C20.277239,11.0362282 20.3543236,11.1133128 20.4247532,11.1962846 Z",
    id: "Triangle-Copy",
    fill: "#0EA57A",
    mask: "url(#mask-13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.75,35.25 L23.25,35.25",
    id: "Line",
    strokeOpacity: 0.1,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75,17.25 L23.25,17.25",
    id: "Line-Copy",
    strokeOpacity: 0.1,
    stroke: "#000000",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "square"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Toolbar",
    transform: "translate(0.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "nav-container",
    fill: "#4C97FF",
    x: 0,
    y: 0,
    width: 321,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    opacity: 0.5,
    x: 126,
    y: 3,
    width: 35.25,
    height: 12,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#FF8000",
    opacity: 0.75,
    x: 164.25,
    y: 3,
    width: 19.5,
    height: 12,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#FFBF00",
    x: 273.75,
    y: 3,
    width: 12,
    height: 12,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    strokeOpacity: 0.15,
    stroke: "#000000",
    strokeWidth: 1.5,
    opacity: 0.75,
    x: 187.5,
    y: 3.75,
    width: 41.25,
    height: 10.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "logo",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    fill: "#FFAB19",
    x: 11.25,
    y: 5.25,
    width: 19.5,
    height: 7.5,
    rx: 3.75
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFFFFF",
    x: 51.75,
    y: 7.5,
    width: 12,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 43.5,
    cy: 9,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    fill: "#FFFFFF",
    cx: 262.5,
    cy: 9,
    r: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#FFFFFF",
    x: 70.5,
    y: 7.5,
    width: 12,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#FFFFFF",
    x: 93,
    y: 7.5,
    width: 22.5,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#FFFFFF",
    x: 291,
    y: 7.5,
    width: 22.5,
    height: 3,
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chrome"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#E9F1FC",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-15)",
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fillOpacity: 0.15,
    fill: "#000000",
    cx: 15,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    fillOpacity: 0.15,
    fill: "#000000",
    cx: 27,
    cy: 12,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fillOpacity: 0.15,
    fill: "#000000",
    cx: 39,
    cy: 12,
    r: 3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#59C059",
    x: 197,
    y: 45,
    width: 8,
    height: 6,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#379438",
    x: 197,
    y: 45,
    width: 1,
    height: 9,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Polygon",
    fill: "#E64D00",
    transform: "translate(214.000000, 49.000000) rotate(22.500000) translate(-214.000000, -49.000000) ",
    points: "214 45 216.828427 46.1715729 218 49 216.828427 51.8284271 214 53 211.171573 51.8284271 210 49 211.171573 46.1715729"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.b40735da4d102dfe583a9f636d160d91.svg";
export { ForwardRef as ReactComponent };